import React from "react";
import { BrowserRouter } from "react-router-dom";
import { renderRoutes } from "react-router-config";

import authRoutes from "../modules/auth/routes";
import branchesRegisterRoutes from "../modules/branchesRegister/routes";
import partnersRoutes from "../modules/partners/routes";
import paymentsRoutes from "../modules/payments/routes";
import SecurityLayout from "../layouts/SecurityLayout";

export const config = [
    authRoutes,
    {
        id: "common",
        path: "/",
        name: "Общие",
        hide: false,
        component: SecurityLayout,
        routes: [...branchesRegisterRoutes, ...paymentsRoutes, ...partnersRoutes],
    },
];

const WebRouterConfig = () => (
    <BrowserRouter>{renderRoutes(config)}</BrowserRouter>
);

export default WebRouterConfig;
